import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  BusinessUnitFilter,
  DisciplineFilter,
  LocationFilter,
  PlaceholderStatusFilter,
  PracticeFilter,
  SkillFilter,
} from '~/components/filters';

export default function PlaceholderFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      placeholderPractices: isVisible('placeholderPractices'),
      placeholderBusinessUnits: isVisible('placeholderBusinessUnits'),
      placeholderDisciplines: isVisible('placeholderDisciplines'),
      placeholderLocations: isVisible('placeholderLocations'),
      placeholderSkills: isVisible('placeholderSkills'),
      placeholderStatusId: isVisible('placeholderStatusId'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.placeholderPractices && (
        <PracticeFilter
          placeholder="Placeholder Practice"
          value={filters.placeholderPractices}
          onChange={({ target: { value } }) => onChange({ placeholderPractices: value })}
        />
      )}

      {visible.placeholderBusinessUnits && (
        <BusinessUnitFilter
          placeholder="Placeholder Business Unit"
          value={filters.placeholderBusinessUnits}
          onChange={({ target: { value } }) => onChange({ placeholderBusinessUnits: value })}
        />
      )}

      {visible.placeholderDisciplines && (
        <DisciplineFilter
          placeholder="Placeholder Discipline"
          value={filters.placeholderDisciplines}
          onChange={({ target: { value } }) => onChange({ placeholderDisciplines: value })}
        />
      )}

      {visible.placeholderLocations && (
        <LocationFilter
          placeholder="Placeholder Location"
          value={filters.placeholderLocations}
          onChange={({ target: { value } }) => onChange({ placeholderLocations: value })}
        />
      )}

      {visible.placeholderSkills && (
        <SkillFilter
          placeholder="Placeholder Skills"
          value={filters.placeholderSkills}
          onChange={({ target: { value } }) => onChange({ placeholderSkills: value })}
        />
      )}

      {visible.placeholderStatusId && (
        <PlaceholderStatusFilter
          value={filters.placeholderStatusId}
          onChange={({ target: { value } }) => onChange({ placeholderStatusId: value })}
        />
      )}
    </>
  );
}
